import * as c from '../constants/constant_action_types';

export default function (state = {}, action) {
  switch (action.type) {
    case c.INITIALIZE_SUMMARY_TYPE:
    case c.FETCHING_SUMMARY_TYPE:
    case c.SUCCESS_FETCHING_SUMMARY_TYPE:
    case c.ERROR_FETCHING_SUMMARY_TYPE: {

      const { summary_type } = action.payload;

      return {
        ...state,
        [ summary_type ]: summaryTypeReducer(state[ summary_type ], action)
      }
    }

    default: return state
  }
}

const INIT_STATE_SUMMARY_TYPE = {
  error: {
    message: '',
    status: false
  },
  isSuccess: false,
  isLoading: false,
  data: []
}

function summaryTypeReducer(state = INIT_STATE_SUMMARY_TYPE, action) {
  switch (action.type) {
    case c.INITIALIZE_SUMMARY_TYPE: {
      return INIT_STATE_SUMMARY_TYPE
    }

    case c.FETCHING_SUMMARY_TYPE: {
      return {
        ...state,
        isLoading: true,
        isSuccess: false
      };
    }

    case c.SUCCESS_FETCHING_SUMMARY_TYPE: {
      const { data } = action.payload || {};

      return {
        ...state,
        data,
        isLoading: false,
        isSuccess: true
      };
    }

    case c.ERROR_FETCHING_SUMMARY_TYPE: {
      const { message } = action.payload || {};

      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        error: {
          message,
          status: true
        }
      }
    }

    default: return state
  }
}
